import { userCache } from "@/shared-utils";
import { useActiveTask } from "./useActiveTask";
import { useAgentSdk } from "./useAgentSdk";

/** Provides the canonical partner for the active task/session, if no task exists returns partner assigned to worker */
export function usePartner() {
    const activeTask = useActiveTask();
    const agentSdk = useAgentSdk();
    // TODO: This is unsafe, technically `[partner]` could be undefined, but TypeScript doesn't recognize that. That's ok, because agentSDK should
    //       always have at least one partner, but we should still have our types reflect that somehow in the future.
    //FIXME: this isn't safe since its possible for an expert to have multiple partners and just picking one is dirty.
    const [partner] = agentSdk.getPartners();
    //Specifically for simulated voice tasks, we want to return the partner from the sdk and not the task partner
    return activeTask?.partner ?? partner ?? userCache.partner;
}
